<template>
  <div v-loading.fullscreen.lock="loading">
    <el-dialog title="账号认证" :visible.sync="rzFormVisible" custom-class="dialog-t" width="677px" :before-close="clearDl">
      <upload-img @submitupload="handleSubmit" ref="uploaditem"></upload-img>
    </el-dialog>
  </div>
</template>

<script>
import uploadImg from '@/components/common/uploadImg/uploadImg'
import { userResource } from '@/resource/resource'
import { mapMutations } from 'vuex'

const ERR_OK = 0

export default {
  name: 'uploadDialog',
  data () {
    return {
      rzFormVisible: false,
      loading: false
    }
  },
  methods: {
    showDialog(status) {
      this.rzFormVisible = status
    },
    clearDl(done) {
      done()
      this.$refs.uploaditem.cleanDl()
    },
    handleSubmit(data) {
      let formData = new FormData()
      formData.append('UploadForm[bank_card]', data.bank_card, data.bank_card_name)
      // console.log('********将blob对象转成formData对象********')
      // console.log(formData.get('UploadForm[bank_card]'))
      formData.append('UploadForm[name]', data.name)
      formData.append('UploadForm[ID_card_front]', data.ID_card_front, data.ID_card_front_name)
      // console.log(formData.get('UploadForm[ID_card_front]'))
      formData.append('UploadForm[ID_card_back]', data.ID_card_back, data.ID_card_back_name)
      // console.log(formData.get('UploadForm[ID_card_back]'))
      this.loading = true
      userResource.upload(formData).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.$alert(res.data, '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.rzFormVisible = false
              this.getUserInfo()
            }
          })
        }
      })
      // this.rzFormVisible = false
    },
    getUserInfo() {
      userResource.info().then(res => {
        res = res.body
        if (res.errcode === ERR_OK) {
          this.AUTO_USERINFO(res.data)
        }
      })
    },
    ...mapMutations([
      'AUTO_USERINFO'
    ])
  },
  components: {
    uploadImg
  }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// uploadDialog.vue?4012d383